import React, { useEffect, useState } from 'react';
import icon from '../assets/icon.png';
import heroOne from '../assets/s1.jpg';
import heroTwo from '../assets/s2.jpg';
import heroThree from '../assets/s3.png';
import heroFour from '../assets/s4.jpg';
import heroFive from '../assets/s5.jpg';
import heroSix from '../assets/s6.jpg';
import { Buttons } from '../components/Buttons';
import { offer, values, process } from '../Data/data';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

const Property = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const heroSlides = [
    { image: heroOne, alt: 'Modern San Francisco property exterior' },
    { image: heroTwo, alt: 'Elegant managed property interior' },
    { image: heroThree, alt: 'Bright residential living space' },
    { image: heroFour, alt: 'Contemporary Bay Area property' },
    { image: heroFive, alt: 'Contemporary Bay Area property' },
    { image: heroSix, alt: 'Contemporary Bay Area property' },
  ];

  const changeSlide = (direction) => {
    setActiveSlide((current) => (current + direction + heroSlides.length) % heroSlides.length);
  };

  useEffect(() => {
    const autoplay = setInterval(() => {
      setActiveSlide((current) => (current + 1) % heroSlides.length);
    }, 3000);

    return () => clearInterval(autoplay);
  }, [heroSlides.length]);

  const visibleSlides = [
    heroSlides[activeSlide],
    heroSlides[(activeSlide + 1) % heroSlides.length],
  ];

  return (
    <div className="w-full bg-black">

      {/* Hero */}
      <div className="w-full bg-[#1A1A1A] px-[4rem] py-[5rem] flex flex-col items-center gap-[1rem] text-center border-b border-[#262626]">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Full-Service Real Estate & Property Management</p>
        </div>
        <h1 className="text-[55px] leading-tight font-bold text-gradient">
          Professional Property Management in San Francisco & Bay Area
        </h1>
        <p className="text-white text-[18px] font-light max-w-[900px]">
          With over 20 years of industry experience, we provide professional real estate and property management solutions across the San Francisco and Bay Area. From residential homes to commercial properties and shopping centers, our licensed team is dedicated to protecting your investment and maximizing your returns.
        </p>
        <div className="flex gap-[1rem] mt-[1rem] flex-wrap justify-center">
          <Buttons title="Get A Free Quote" width="210px" to="/contact" />
          <Link to="/contact">
            <button className="py-[0.8rem] px-[2rem] text-white font-semibold rounded-lg border border-[#EEC24B] hover:bg-[#EEC24B] hover:text-black transition-all duration-300">
              Schedule Consultation
            </button>
          </Link>
        </div>

        <div className="w-full max-w-[1180px] mt-[2rem]">
          <div className="relative overflow-hidden rounded-xl border border-[#3a3a3a] bg-black shadow-[0_20px_60px_rgba(0,0,0,0.35)]">
            <div className="relative h-[220px] sm:h-[300px] lg:h-[480px] p-[0.5rem] sm:p-[0.75rem]">
              <div className="grid h-full grid-cols-2 gap-[0.5rem] sm:gap-[0.75rem]">
                {visibleSlides.map((slide) => (
                  <img
                    key={slide.image}
                    src={slide.image}
                    alt={slide.alt}
                    className="h-full w-full rounded-lg object-cover object-bottom"
                  />
                ))}
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute bottom-[1rem] left-[1rem] right-[1rem] flex items-end justify-between gap-[1rem] sm:bottom-[1.5rem] sm:left-[1.5rem] sm:right-[1.5rem]">
                {/* <p className="text-left text-[13px] font-medium uppercase tracking-[0.18em] text-white/85 sm:text-[15px]">
                  Bay Area properties, expertly managed
                </p> */}
                <div className="flex shrink-0 gap-[0.5rem]">
                  <button
                    type="button"
                    onClick={() => changeSlide(-1)}
                    aria-label="Previous property image pair"
                    className="flex h-[36px] w-[36px] items-center justify-center rounded-full border border-white/40 bg-black/35 text-[20px] leading-none text-white backdrop-blur-sm transition-colors hover:border-[#EEC24B] hover:text-[#EEC24B] focus:outline-none focus:ring-2 focus:ring-[#EEC24B]"
                  >
                    &#8592;
                  </button>
                  <button
                    type="button"
                    onClick={() => changeSlide(1)}
                    aria-label="Next property image pair"
                    className="flex h-[36px] w-[36px] items-center justify-center rounded-full border border-white/40 bg-black/35 text-[20px] leading-none text-white backdrop-blur-sm transition-colors hover:border-[#EEC24B] hover:text-[#EEC24B] focus:outline-none focus:ring-2 focus:ring-[#EEC24B]"
                  >
                    &#8594;
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-[1rem] flex justify-center gap-[0.5rem]" aria-label="Property image slides">
            {heroSlides.map((slide, index) => (
              <button
                key={slide.image}
                type="button"
                onClick={() => setActiveSlide(index)}
                aria-label={`View property image ${index + 1}`}
                aria-current={index === activeSlide}
                className={`h-[5px] rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#EEC24B] ${index === activeSlide ? 'w-[30px] bg-[#EEC24B]' : 'w-[10px] bg-[#666] hover:bg-white'}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Services */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Comprehensive Real Estate & Property Management Services</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">What We Offer</h2>
            <p className="text-white text-[18px] font-light max-w-[800px] mx-auto">
              We provide full-service real estate and property management solutions throughout San Francisco and the Bay Area. Our services are designed to protect your investment, increase occupancy, streamline operations, and maximize property value.
            </p>
          </div>

          <div className="flex flex-col gap-[3rem]">
            {offer.map((item, index) => (
              <div
                key={item.id}
                className={`flex flex-wrap gap-[3rem] items-center ${index % 2 === 1 ? 'flex-row-reverse' : ''}`}
              >
                <div className="flex-1 min-w-[280px]">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-[320px] object-cover rounded-lg border border-[#262626]"
                  />
                </div>
                <div className="flex-1 min-w-[280px] flex flex-col gap-[1.2rem]">
                  <h3 className="text-gradient text-[28px] font-bold">{item.title}</h3>
                  <p className="text-white text-[17px] font-light">{item.detail}</p>
                  <ul className="flex flex-col gap-[0.7rem]">
                    {item.point.map((p, i) => (
                      <li key={i} className="flex items-start gap-[0.8rem]">
                        <FaCheckCircle className="text-[#EEC24B] mt-1 flex-shrink-0" size={16} />
                        <p className="text-white text-[16px] font-light">{p}</p>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-[0.5rem]">
                    <Buttons title={item.button} width="100%" to="/contact" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">What Drives Us</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Our Core Values</h2>
          </div>
          <div className="flex flex-wrap gap-[2rem] justify-center">
            {values.map((val) => (
              <div
                key={val.id}
                className="flex-1 min-w-[220px] max-w-[320px] bg-[#111] border border-[#262626] rounded-lg p-[2rem] flex flex-col gap-[1rem] hover:border-[#EEC24B] transition-all duration-300"
              >
                <img src={val.img} alt={val.title} className="w-[50px] h-[50px] object-contain" />
                <h3 className="text-gradient text-[22px] font-bold">{val.title}</h3>
                <p className="text-[#999] text-[16px] font-light">{val.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Process */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Our Proven Approach</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">How We Manage Your Property</h2>
            <p className="text-white text-[18px] font-light max-w-[800px] mx-auto">
              From initial consultation to ongoing optimization, our structured process ensures maximum performance for your property.
            </p>
          </div>

          <div className="flex flex-wrap gap-[1.5rem] justify-center">
            {process.map((step, i) => (
              <div
                key={step.id}
                className="flex-1 min-w-[260px] max-w-[380px] bg-[#1A1A1A] border border-[#262626] rounded-lg p-[2rem] flex flex-col gap-[1rem] hover:border-[#EEC24B] transition-all duration-300"
              >
                <div className="flex items-center gap-[1rem]">
                  <span className="gradient text-black font-bold text-[18px] w-[40px] h-[40px] rounded-full flex items-center justify-center flex-shrink-0">
                    {step.id}
                  </span>
                  <h3 className="text-white text-[20px] font-bold">{step.title}</h3>
                </div>
                <p className="text-[#999] text-[16px] font-light">{step.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] text-center flex flex-col gap-[1.5rem] items-center">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Ready to Maximize Your Investment?</p>
        </div>
        <h2 className="text-[45px] font-bold text-gradient">Let's Manage Your Property</h2>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Whether you own a single home or a large commercial portfolio, our team is ready to deliver professional, results-driven property management across the Bay Area.
        </p>
        <div className="flex gap-[1rem] flex-wrap justify-center">
          <Buttons title="Get A Free Quote" width="210px" to="/contact" />
          <Link to="/contact">
            <button className="py-[0.8rem] px-[2rem] text-white font-semibold rounded-lg border border-[#EEC24B] hover:bg-[#EEC24B] hover:text-black transition-all duration-300">
              Contact Us Today
            </button>
          </Link>
        </div>
      </div>

    </div>
  );
};

export default Property;
